import { invoiceApiService } from './invoice-api';
import { transactionApiService } from './transaction-api';
import { commissionsApiService } from './commissions-api';
import { taxInfoApiService } from './tax-info-api';

/**
 * Unified API interface for the ERP module
 * Provides a single entry point for all ERP-related API calls
 */
export const erpApi = {
    // Receivables (Cuentas por Cobrar) - Uses Invoice API
    receivables: {
        getAll: invoiceApiService.getInvoices.bind(invoiceApiService),
        getById: invoiceApiService.getInvoice.bind(invoiceApiService),
        getStats: invoiceApiService.getStats.bind(invoiceApiService),
        getOverdue: invoiceApiService.getOverdueInvoices.bind(invoiceApiService),
        download: invoiceApiService.downloadInvoice.bind(invoiceApiService),
        create: invoiceApiService.createInvoice.bind(invoiceApiService),
    },

    // Cash Flow (Flujo de Caja) - Uses Transaction API
    cashFlow: {
        getAll: transactionApiService.getTransactions.bind(transactionApiService),
        getById: transactionApiService.getTransaction.bind(transactionApiService),
        create: transactionApiService.createTransaction.bind(transactionApiService),
        update: transactionApiService.updateTransaction.bind(transactionApiService),
        delete: transactionApiService.deleteTransaction.bind(transactionApiService),
        getStats: transactionApiService.getStats.bind(transactionApiService),
    },

    // Commissions (Comisiones) - Uses Commission API
    commissions: {
        getAll: commissionsApiService.getCommissions.bind(commissionsApiService),
        getById: commissionsApiService.getCommission.bind(commissionsApiService),
        getStats: commissionsApiService.getCommissionStats.bind(commissionsApiService),
        addPayment: commissionsApiService.addPayment.bind(commissionsApiService),
        updateStatus: commissionsApiService.updateStatus.bind(commissionsApiService),
    },
    taxInfo: {
        get: taxInfoApiService.getTaxInfo.bind(taxInfoApiService),
        create: taxInfoApiService.createTaxInfo.bind(taxInfoApiService),
        update: taxInfoApiService.updateTaxInfo.bind(taxInfoApiService),
    },
};

export default erpApi;
